import React from "react";

interface LoadingScreenProps {
  message?: string;
  isVisible: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = "Hold tight while we're creating your agent...",
  isVisible,
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black bg-opacity-70 backdrop-blur-md"></div>
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-6">
        <div className="w-16 h-16 mb-6">
          <svg
            className="animate-spin text-lime-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>

        <h2 className="text-2xl font-bold text-lime-400 mb-2">
          CREATING AGENT
        </h2>
        <p className="text-white text-lg">{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
